import Vue from 'vue';
export const EventBus = new Vue();


// WEBPACK FOOTER //
// ./src/plugins/event-bus.js